import React, { useContext } from "react";
import { Typography, Menu, MenuItem, ListItemIcon, Fade } from "@material-ui/core";
import NewPaymentIcon from "@material-ui/icons/PlaylistAddTwoTone";
import ScheduleIcon from '@material-ui/icons/ScheduleTwoTone';
import ExportIcon from "@material-ui/icons/GetAppTwoTone";
import DownloadIcon from "@material-ui/icons/CloudDownloadTwoTone";
import DownloadSelectedIcon from "@material-ui/icons/CloudDoneTwoTone";

import translate from "../i18n/Translator";
import { AppContext } from "../context/AppContext";

interface CustomersMenuProps {
    anchor: HTMLElement | null;
    selected: number;
    totalItems?: number;
    paymentStatus?: string;
    onClose(): any;
    onNewPayment(): any;
    onRegisterPayment(): any;
    onExportCfdis(): any;
    onDownloadCfdis(): any;
    onDownloadSelectedCfdis(): any;
}

export default function CfdisMenu(props: CustomersMenuProps) {
    const context = useContext(AppContext);

    return (
        <Menu
            id="customers-menu"
            anchorEl={props.anchor}
            keepMounted
            onClose={props.onClose}
            open
            TransitionComponent={Fade}
            autoFocus={false}
            variant="selectedMenu"
        >
            <MenuItem button onClick={props.onExportCfdis} dense disabled={props.totalItems === undefined || props.totalItems === 0}>
                <ListItemIcon>
                    <ExportIcon fontSize="small" color="primary" />
                </ListItemIcon>
                <Typography variant="inherit">{translate("buttons.export_cfdis")}</Typography>
            </MenuItem>
            <MenuItem button onClick={props.onDownloadCfdis} dense disabled={props.totalItems === undefined || props.totalItems === 0}>
                <ListItemIcon>
                    <DownloadIcon fontSize="small" color="primary" />
                </ListItemIcon>
                <Typography variant="inherit">{translate("buttons.download_cfdis")}</Typography>
            </MenuItem>
            <MenuItem button onClick={props.onDownloadSelectedCfdis} dense disabled={props.selected === 0}>
                <ListItemIcon>
                    <DownloadSelectedIcon fontSize="small" color="primary" />
                </ListItemIcon>
                <Typography variant="inherit">{translate("buttons.download_selected")}</Typography>
            </MenuItem>
            {context.isGranted("CustomersPaymentsCreate") && props.paymentStatus === "pending" && (
                <MenuItem button onClick={props.onRegisterPayment} dense disabled={props.selected > 0}>
                    <ListItemIcon>
                        <NewPaymentIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.register_payment")}</Typography>
                </MenuItem>
            )}
            {context.isGranted("CustomersPaymentsCreate") && props.paymentStatus === "pending" && (
                <MenuItem button onClick={props.onNewPayment} dense disabled={props.selected <= 0}>
                    <ListItemIcon>
                        <ScheduleIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.new_payment")}</Typography>
                </MenuItem>
            )}
        </Menu>
    );

} 